import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Home, Search } from "lucide-react";
import { CartContext } from "../context/CartContext";

const FloatingCartButton = () => {
  const { cartCount } = useContext(CartContext);

  // Hacer scroll a la sección de búsqueda y enfocar el input
  const handleScrollToSearch = () => {
    const searchSection = document.getElementById("search-bar-section");
    if (searchSection) {
      // Desplaza suavemente hasta la sección
      searchSection.scrollIntoView({ behavior: "smooth" });
      // Tras un pequeño delay, hacemos focus en el input
      setTimeout(() => {
        const searchInput = document.getElementById("searchInput");
        if (searchInput) {
          searchInput.focus();
        }
      }, 600); // 600 ms de retardo aproximado
    }
  };

  return (
    <>
      {/* Botón para ir a la barra de búsqueda */}
      <button
        onClick={handleScrollToSearch}
        className="fixed bottom-32 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-all flex items-center justify-center"
        style={{ width: "60px", height: "60px" }}
      >
        <Search size={30} />
      </button>

      {/* Botón para ir al inicio */}
      <Link
        to="/"
        className="fixed bottom-20 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-all flex items-center justify-center"
        style={{ width: "60px", height: "60px" }}
      >
        <Home size={30} />
      </Link>

      {/* Botón para ir al carrito */}
      <Link
        to="/cart"
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-all flex items-center justify-center"
        style={{ width: "60px", height: "60px" }}
      >
        <ShoppingCart size={30} />
        {cartCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
            {cartCount}
          </span>
        )}
      </Link>
    </>
  );
};

export default FloatingCartButton;
